import React from 'react'
import { CustomTable, Loading, PageTitle, Button } from 'src/components'
import { useStyles } from './styles'
import { useCouplePlanningTableHeader } from './hooks/useCouplePlanningTableHeader'
import { useFilterToggler } from 'src/components/CustomTable/hooks/useFilterToggler'
import { useGetCouplePlanningList } from 'src/hooks/api/couple-planning'
import { Link } from 'react-router-dom'
import ROUTES from 'src/constants/routes'
import { more } from 'src/assets/png'
import { Filter } from 'src/assets/svg'

export const CouplePlanning: React.FC = () => {
  const style = useStyles()

  const { tableHeader } = useCouplePlanningTableHeader()
  const { filterIsActive, handleFilter } = useFilterToggler()

  const { data: couplePlanningList = [], isLoading, isError, refetch, isRefetching } = useGetCouplePlanningList()
  const isLoadingData = isLoading || isRefetching

  return (
    <>
      <div className={style.propertiesHeader}>
        <PageTitle title='Casal Planejado' />

        <div className={style.buttonContainer}>
          <Button secondary disabled={isLoading} onClick={handleFilter} outlined>
            <Filter className='icon' />
            FILTRAR
          </Button>

          <Link to={ROUTES.COUPLE_PLANNING.NEW}>
            <Button>
              <img src={more} alt='Incluir' />
              CADASTRAR
            </Button>
          </Link>
        </div>
      </div>

      <div className={style.propertiesContainer}>
        {isLoadingData || isError ? (
          <Loading isError={isError} refetch={refetch} />
        ) : (
          <CustomTable
            filterIsActive={filterIsActive}
            propertiesToFilter={['nomeVaca', 'nomeTouro', 'reproducao', 'dataInicio', 'tipoMonta', 'inseminador']}
            filterPlaceholder='Filtrar por Vaca, Touro, Inseminador...'
            body={couplePlanningList}
            header={tableHeader}
          />
        )}
      </div>
    </>
  )
}
